(function () {
  if (customElements.get('ce-history-back') !== undefined) {
    return;
  }

  class HistoryBack extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        button: '[data-history-back-button]',
      };

      this.elements = null;

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        button: this.querySelector(this.selectors.button),
      };

      this.elements.button.addEventListener('click', this.handleClickButton);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.handleClickButton);
    }

    handleClickButton() {
      history.back();
    }
  }

  customElements.define('ce-history-back', HistoryBack);
})();
